// A sea turtle, modelled facing +X: a low green domed shell, four flippers and a
// small head. Ported 1:1 from age-of-mcp's classic sea-turtle.ts, restoring its
// shell/head core and the angled-flipper loop.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  const parts: Part[] = [
    { geometry: new THREE.IcosahedronGeometry(0.044, 0), color: "#3e6e4a",
      position: [0, 0.022, 0], scale: [1.3, 0.55, 1.1] },           // shell
    { geometry: new THREE.IcosahedronGeometry(0.02, 0), color: "#5a8a5e",
      position: [0.054, 0.018, 0], scale: [1.2, 0.8, 0.9] },        // head
  ];
  // Four flippers angled out from the shell.
  for (const [x, z, rot] of [[0.03, 0.04, 0.6], [0.03, -0.04, -0.6],
                             [-0.03, 0.04, 0.9], [-0.03, -0.04, -0.9]]) {
    parts.push({ geometry: new THREE.IcosahedronGeometry(0.018, 0),
      color: "#4a7a52", position: [x!, 0.014, z!],
      rotation: [0, rot!, 0], scale: [1.6, 0.35, 0.8] });
  }
  return parts;
}

export const seaTurtle = defineModel({
  id: "sea-turtle",
  scale: 4.59, // real-world size correction (see Model.scale)
  batchId: "standard",
  name: "Sea turtle",
  tags: ["creature","sea","turtle","low-poly","age-of-mcp","classic","water"],
  summary: "Low-poly sea turtle.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.1,
  parts: () => partsFor(),
  animations: [],
});
